import { render, staticRenderFns } from "./ot-contract-documents-index.vue?vue&type=template&id=42e83a98&scoped=true&"
import script from "./ot-contract-documents-index.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-documents-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-documents-index.vue?vue&type=style&index=0&id=42e83a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e83a98",
  null
  
)

export default component.exports